import leadFunnel from './leadFunnel';

export default {
  LeadFunnel: leadFunnel,
};
